import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import SendTestMailModal from '@/components/admin/mails/SendTestMailModal';
import MailsTable from '@/components/admin/mails/MailsTable';
import { faArrowLeft, faPlus } from '@/fontawesome';

export default function AdminMailsList() {
  const [total, setTotal] = useState(0);
  const [reloadKey, setReloadKey] = useState(0);
  const [isTestMailModalOpen, setIsTestMailModalOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-between mb-8">
          <div className="flex items-center">
            <Link
              to="/admin"
              className="mr-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="w-5 h-5" />
            </Link>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              E-Mails ({total})
            </h1>
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => setIsTestMailModalOpen(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer"
            >
              <FontAwesomeIcon icon={faPlus} className="w-4 h-4" />
              <span>Test-Mail senden</span>
            </button>
          </div>
        </div>

      <MailsTable reloadKey={reloadKey} onTotalChange={setTotal} />

      <SendTestMailModal
        isOpen={isTestMailModalOpen}
        onClose={() => setIsTestMailModalOpen(false)}
        onTestMailSent={() => setReloadKey(k => k + 1)}
      />
    </>
  );
}
